<template>
    <div class="view--sign-main">
        <div class="columns">

            <div class="column">
                <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Services</p></div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Park Position</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.parkPosition" v-model="InputsObject.BTO.parkPosition" readonly>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">GPU</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control" v-if="InputsObject.BTO.gpu">
                                <label class="radio" >
                                    <input  type="radio" name="answer" v-if="InputsObject.BTO.gpu == 'true'" checked="checked">
                                    Yes
                                </label>
                                <label class="radio">
                                    <input type="radio" name="answer" v-if="InputsObject.BTO.gpu == 'false'" checked="checked">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">ACU</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control" v-if="InputsObject.BTO.acu">
                                <label class="radio">
                                    <input class="radioButton is-size-3" type="radio" name="answer2" v-if="InputsObject.BTO.acu == 'true'" checked="checked">
                                    Yes
                                </label>
                                <label class="radio">
                                    <input type="radio" name="answer2" v-if="InputsObject.BTO.acu == 'false'" checked="checked">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">ASU</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control" v-if="InputsObject.BTO.asu">
                                <label class="radio">
                                    <input type="radio" name="answer3" v-if="InputsObject.BTO.asu == 'true'" checked="checked">
                                    Yes
                                </label>
                                <label class="radio">
                                    <input type="radio" name="answer3" v-if="InputsObject.BTO.asu == 'false'" checked="checked">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div class="column">
                <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Cargo/Bag</p></div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Cargo(Kg)</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="number" v-if="InputsObject.BTO.cargo" v-model="InputsObject.BTO.cargo" readonly>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="columns">

            <div class="column">

                <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Pax OnBoard</p></div>

<!--                <div class="field is-horizontal">-->
<!--                    <div class="field-label is-normal">-->
<!--                        <label class="label">Adult</label>-->
<!--                    </div>-->
<!--                    <div class="field-body">-->
<!--                        <div class="field">-->
<!--                            <div class="control">-->
<!--                                <input class="input" type="text" v-if="InputsObject.BTO.paxOnboardAdult" v-model="InputsObject.BTO.paxOnboardAdult" readonly>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Male</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxOnboardMale" v-model="InputsObject.BTO.paxOnboardMale" readonly>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Female</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxOnboardFemale" v-model="InputsObject.BTO.paxOnboardFemale" readonly>
                            </div>
                        </div>
                    </div>
                </div>



                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Child</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxOnboardChild" v-model="InputsObject.BTO.paxOnboardChild" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Infant</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxOnboardInfant" v-model="InputsObject.BTO.paxOnboardInfant" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">PAD</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxOnboardPAD" v-model="InputsObject.BTO.paxOnboardPAD" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">DHC</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxOnboardDHC" v-model="InputsObject.BTO.paxOnboardDHC" readonly>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="column">

                <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Pax Check-In</p></div>

<!--                <div class="field is-horizontal">-->
<!--                    <div class="field-label is-normal">-->
<!--                        <label class="label">Adult</label>-->
<!--                    </div>-->
<!--                    <div class="field-body">-->
<!--                        <div class="field">-->
<!--                            <div class="control">-->
<!--                                <input class="input" type="text" v-if="InputsObject.BTO.paxCheckInAdult" v-model="InputsObject.BTO.paxCheckInAdult" readonly>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Male</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxCheckInMale" v-model="InputsObject.BTO.paxCheckInMale" readonly>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Female</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxCheckInFemale" v-model="InputsObject.BTO.paxCheckInFemale" readonly>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Child</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxCheckInChild" v-model="InputsObject.BTO.paxCheckInChild" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Infant</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxCheckInInfant" v-model="InputsObject.BTO.paxCheckInInfant" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">PAD</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxCheckInPAD" v-model="InputsObject.BTO.paxCheckInPAD" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">DHC</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxCheckInDHC" v-model="InputsObject.BTO.paxCheckInDHC" readonly>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div class="column">

                <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Pax Transit-Dep</p></div>

<!--                <div class="field is-horizontal">-->
<!--                    <div class="field-label is-normal">-->
<!--                        <label class="label">Adult</label>-->
<!--                    </div>-->
<!--                    <div class="field-body">-->
<!--                        <div class="field">-->
<!--                            <div class="control">-->
<!--                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitAdult" v-model="InputsObject.BTO.paxTransitAdult" readonly>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Male</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitMale" v-model="InputsObject.BTO.paxTransitMale" readonly>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Female</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitFemale" v-model="InputsObject.BTO.paxTransitFemale" readonly>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Child</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitChild" v-model="InputsObject.BTO.paxTransitChild" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Infant</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitInfant" v-model="InputsObject.BTO.paxTransitInfant" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">PAD</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitPAD" v-model="InputsObject.BTO.paxTransitPAD" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">DHC</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitDHC" v-model="InputsObject.BTO.paxTransitDHC" readonly>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class = "columns">

            <div class="column">

                <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Pax Transit-Arr</p></div>

<!--                <div class="field is-horizontal">-->
<!--                    <div class="field-label is-normal">-->
<!--                        <label class="label">Adult</label>-->
<!--                    </div>-->
<!--                    <div class="field-body">-->
<!--                        <div class="field">-->
<!--                            <div class="control">-->
<!--                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitArrAdult" v-model="InputsObject.BTO.paxTransitArrAdult" readonly>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Male</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitArrMale" v-model="InputsObject.BTO.paxTransitArrMale" readonly>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Female</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitArrFemale" v-model="InputsObject.BTO.paxTransitArrFemale" readonly>
                            </div>
                        </div>
                    </div>
                </div>



                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Child</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitArrChild" v-model="InputsObject.BTO.paxTransitArrChild" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Infant</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitArrInfant" v-model="InputsObject.BTO.paxTransitArrInfant" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">PAD</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitArrPAD" v-model="InputsObject.BTO.paxTransitArrPAD" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">DHC</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxTransitArrDHC" v-model="InputsObject.BTO.paxTransitArrDHC" readonly>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="column">

                <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Pax Check-Out</p></div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Male</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxCheckOutMale" v-model="InputsObject.BTO.paxCheckOutMale" readonly>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Female</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxCheckOutFemale" v-model="InputsObject.BTO.paxCheckOutFemale" readonly>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Child</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxCheckOutChild" v-model="InputsObject.BTO.paxCheckOutChild" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Infant</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxCheckOutInfant" v-model="InputsObject.BTO.paxCheckOutInfant" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">PAD</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxCheckOutPAD" v-model="InputsObject.BTO.paxCheckOutPAD" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">DHC</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-if="InputsObject.BTO.paxCheckOutDHC" v-model="InputsObject.BTO.paxCheckOutDHC" readonly>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="column">

                <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Total</p></div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Male</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text"  v-model="TotalMale" readonly>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Female</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-model="TotalFemale" readonly>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Child</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" v-model="TotalChild" readonly>
                            </div>
                        </div>
                    </div>
                </div>
                <!--
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Infant</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" type="text"  v-model="TotalInfant" readonly>
                                    </div>
                                </div>
                            </div>
                        </div>
                -->
            </div>

        </div>

        <br>
    </div>
</template>

<script>
    import {loadingMixin} from "../../../utils/mixins";
    import {mapState} from "vuex";
    import {createUrl} from "../../../http";

    export default {
        name: "PaxInformation",
        props: ["id", "flight"],
        mixins: [loadingMixin],
        data() {
            return {
                OFPdata :"",
                CategoryInfos : [],
                getSvgSignatureUrl : "",
                activeSvgUrl : createUrl('/EffIpadPreview/GetInputSVG/'),
                SignatureShow:true,
            }
        },

        computed : {

            ...mapState("ipadmain",[ "selectedFlightItems","EFF_Json_Data","WR_Json_Data","AttachmentsJson","OCCSelfVersions_VS_IPADLastKnownVersions","LastInputsJson","InputsObject"]),

            // ...mapState("viewandsign",["OFPjsonData"]),

            OfpData:function(){
                return this.EFF_Json_Data.poOFP;
            },

            TotalMale : {

                get(){

                    var paxOnboardMale =0;var paxCheckInMale =0;var paxTransitDepMale =0;var paxTransitArrMale =0;var paxCheckOutMale =0;
                    if(this.InputsObject.BTO.paxOnboardMale){paxOnboardMale = parseInt(this.InputsObject.BTO.paxOnboardMale,10)}
                    if(this.InputsObject.BTO.paxCheckInMale){paxCheckInMale = parseInt(this.InputsObject.BTO.paxCheckInMale,10)}
                    if(this.InputsObject.BTO.paxTransitMale){paxTransitDepMale = parseInt(this.InputsObject.BTO.paxTransitMale,10)}
                    if(this.InputsObject.BTO.paxTransitArrMale){paxTransitArrMale = parseInt(this.InputsObject.BTO.paxTransitArrMale,10)}
                    if(this.InputsObject.BTO.paxCheckOutMale){paxCheckOutMale = parseInt(this.InputsObject.BTO.paxCheckOutMale,10)}

                    return paxOnboardMale + paxCheckInMale + paxTransitDepMale + paxTransitArrMale + paxCheckOutMale;
                }
            },

            TotalFemale : {

                get(){
                    var paxOnboardFemale =0;var paxCheckInFemale =0;var paxTransitDepFemale =0;var paxTransitArrFemale =0;var paxCheckOutFemale =0;
                    if(this.InputsObject.BTO.paxOnboardFemale){paxOnboardFemale = parseInt(this.InputsObject.BTO.paxOnboardFemale,10)}
                    if(this.InputsObject.BTO.paxCheckInFemale){paxCheckInFemale = parseInt(this.InputsObject.BTO.paxCheckInFemale,10)}
                    if(this.InputsObject.BTO.paxTransitFemale){paxTransitDepFemale = parseInt(this.InputsObject.BTO.paxTransitFemale,10)}
                    if(this.InputsObject.BTO.paxTransitArrFemale){paxTransitArrFemale = parseInt(this.InputsObject.BTO.paxTransitArrFemale,10)}
                    if(this.InputsObject.BTO.paxCheckOutFemale){paxCheckOutFemale = parseInt(this.InputsObject.BTO.paxCheckOutFemale,10)}

                    return paxOnboardFemale + paxCheckInFemale + paxTransitDepFemale + paxTransitArrFemale + paxCheckOutFemale;
                }

            },

            TotalChild : {
                get(){
                    var paxOnboardInfant =0;var paxCheckInChild =0;var paxTransitDepChild =0;var paxTransitArrChild =0;var paxCheckOutChild =0;
                    if(this.InputsObject.BTO.paxOnboardInfant){paxOnboardInfant = parseInt(this.InputsObject.BTO.paxOnboardInfant,10)}
                    if(this.InputsObject.BTO.paxCheckInChild){paxCheckInChild = parseInt(this.InputsObject.BTO.paxCheckInChild,10)}
                    if(this.InputsObject.BTO.paxTransitChild){paxTransitDepChild = parseInt(this.InputsObject.BTO.paxTransitChild,10)}
                    if(this.InputsObject.BTO.paxTransitArrChild){paxTransitArrChild = parseInt(this.InputsObject.BTO.paxTransitArrChild,10)}
                    if(this.InputsObject.BTO.paxCheckOutChild){paxCheckOutChild = parseInt(this.InputsObject.BTO.paxCheckOutChild,10)}

                    return paxOnboardInfant + paxCheckInChild + paxTransitDepChild + paxTransitArrChild + paxCheckOutChild;
                }
            },

            TotalInfant : {
                get(){
                    var paxOnboardInfant =0;var paxCheckInInfant =0;var paxTransitDepInfant =0;var paxTransitArrInfant =0;var paxCheckOutInfant =0;
                    if(this.InputsObject.BTO.paxOnboardInfant){paxOnboardInfant = parseInt(this.InputsObject.BTO.paxOnboardInfant,10)}
                    if(this.InputsObject.BTO.paxCheckInInfant){paxCheckInInfant = parseInt(this.InputsObject.BTO.paxCheckInInfant,10)}
                    if(this.InputsObject.BTO.paxTransitInfant){paxTransitDepInfant = parseInt(this.InputsObject.BTO.paxTransitInfant,10)}
                    if(this.InputsObject.BTO.paxTransitArrInfant){paxTransitArrInfant = parseInt(this.InputsObject.BTO.paxTransitArrInfant,10)}
                    if(this.InputsObject.BTO.paxCheckOutInfant){paxCheckOutInfant = parseInt(this.InputsObject.BTO.paxCheckOutInfant,10)}

                    return paxOnboardInfant + paxCheckInInfant + paxTransitDepInfant + paxTransitArrInfant + paxCheckOutInfant;
                }
            },



        },
        created()
        {
            this.getCategoryInfo();
            this.getSvgSignatureUrl = this.activeSvgUrl + this.id + "/" + this.flight.std + "/" + "BTO_Signature.svg"+"/"+this.flight.flightArchiveStat;
        },

        methods: {
            errorSignatureShow(stat)
            {
                if (stat ==0)
                {
                    this.SignatureShow = false;
                }
                else if(stat ==1)
                {
                    this.SignatureShow = true;
                }
            },

            getCategoryInfo()
            {
                (this.EFF_Json_Data.poOFP.Dep_Cat == "")? "": this.CategoryInfos.push("Dep: "+this.EFF_Json_Data.poZipMain.Dep+" Airport Category is  "+this.EFF_Json_Data.poOFP.Dep_Cat);
                (this.EFF_Json_Data.poOFP.Arr_Cat == "")? "": this.CategoryInfos.push("Dest: "+this.EFF_Json_Data.poZipMain.Arr+" Airport Category is  "+this.EFF_Json_Data.poOFP.Arr_Cat);
                (this.EFF_Json_Data.poOFP.Alt1_Cat == "")? "": this.CategoryInfos.push("Dest Alt: "+this.EFF_Json_Data.poOFP.ARR_alt1+" Airport Category is  "+this.EFF_Json_Data.poOFP.Alt1_Cat);
                (this.EFF_Json_Data.poOFP.Alt2_Cat == "")? "": this.CategoryInfos.push("Dest Alt2: "+this.EFF_Json_Data.poOFP.ARR_alt2+" Airport Category is  "+this.EFF_Json_Data.poOFP.Alt2_Cat);
                (this.EFF_Json_Data.poOFP.DepAlt_Cat == "")? "": this.CategoryInfos.push("Dep Alt: "+this.EFF_Json_Data.poOFP.DEP_alt+" Airport Category is  "+this.EFF_Json_Data.poOFP.DepAlt_Cat);
                (this.EFF_Json_Data.poOFP.Enroute_Cat == "")? "": this.CategoryInfos.push("Enroute: "+this.EFF_Json_Data.poOFP.Enroute+" Airport Category is  "+this.EFF_Json_Data.poOFP.Enroute_Cat);
            },
        }
    }
</script>

<style scoped>
    label {
        width: 150px;
    }
</style>
